<template>
  <div class="global-advanced-portal-student" :class="{ dark }">
    <v-container
      class="config-form-content adminWeeducPortalStudentImage weeduc-admin-config weeduc-admin-portal-student-inner"
      data-aos="fade-left"
      data-aos-duration="1500"
      fluid
    >
      <div class="weeduc-admin-portal-student__intro" id="titleContainerPortalStudent">
        <h3 class="weeduc-admin-portal-student__title">Portal do Aluno</h3>
        <p class="weeduc-admin-portal-student__lead">
          Configurações do portal e da interação com o aluno (certificado, dúvidas, fórum e banner).
        </p>
      </div>

      <v-card
        class="weeduc-admin-portal-student__surface weeduc-admin-portal-student__card"
        variant="outlined"
        rounded="lg"
        elevation="0"
      >
        <v-card-text class="weeduc-admin-portal-student__card-body pa-4 pa-sm-5">
          <div id="contentContainerPortalStudent" class="weeduc-admin-portal-student__layout">
            <div
              id="contentSelectContainerPortalStudent"
              class="weeduc-admin-portal-student__col weeduc-admin-portal-student__col--settings"
            >
              <h4 class="weeduc-admin-portal-student__card-heading labeld required">
                Configurações do Portal do Aluno
              </h4>

              <div class="weeduc-admin-portal-student__field">
                <v-select
                  v-model="showCertificate"
                  :items="optionsAtivoInativo"
                  item-title="text"
                  item-value="value"
                  label="Exibir Certificado"
                  variant="outlined"
                  density="compact"
                  class="weeduc-admin-v-field"
                  :menu-props="adminSelectMenuProps"
                  hide-details="auto"
                />
                <small class="weeduc-admin-portal-student__field-hint">
                  Após a conclusão do curso, o aluno poderá baixar o certificado de conclusão.
                </small>
              </div>

              <div class="weeduc-admin-portal-student__field">
                <v-select
                  v-model="showInquiry"
                  :items="optionsAtivoInativo"
                  item-title="text"
                  item-value="value"
                  label="Exibir Dúvidas"
                  variant="outlined"
                  density="compact"
                  class="weeduc-admin-v-field"
                  :menu-props="adminSelectMenuProps"
                  hide-details="auto"
                />
                <small class="weeduc-admin-portal-student__field-hint">
                  O aluno poderá responder dúvidas para melhorar o curso.
                </small>
              </div>

              <div class="weeduc-admin-portal-student__field">
                <v-select
                  v-model="showForum"
                  :items="optionsAtivoInativo"
                  item-title="text"
                  item-value="value"
                  label="Exibir Fórum"
                  variant="outlined"
                  density="compact"
                  class="weeduc-admin-v-field"
                  :menu-props="adminSelectMenuProps"
                  hide-details="auto"
                />
                <small class="weeduc-admin-portal-student__field-hint">
                  O aluno poderá interagir com o fórum para compartilhar dúvidas e conhecimento.
                </small>
              </div>
            </div>

            <div
              id="contentImageContainerPortalStudent"
              class="weeduc-admin-portal-student__col weeduc-admin-portal-student__col--media"
            >
              <label
                for="portalStudentImageSelect"
                class="labeld required weeduc-admin-portal-student__media-label"
              >
                Imagem do Portal do Aluno
              </label>
              <div class="weeduc-admin-portal-student__upload-zone">
                <CustomFileInput
                  id="portalStudentImageSelect"
                  v-model="image"
                  :image-preview="imagePreview"
                  height="200"
                  :can-delete="false"
                  infoText="Selecione uma imagem no formato JPG ou PNG"
                  @update:modelValue="updateFilePath"
                />
              </div>
              <p class="helper-text weeduc-admin-portal-student__helper">
                Tamanho recomendado: 1280×500 pixels (proporção 16:5)
              </p>
            </div>
          </div>
        </v-card-text>

        <v-card-actions
          id="buttonContainerPortalStudent"
          class="weeduc-admin-portal-student__card-footer weeduc-admin-site-form-actions flex-wrap"
        >
          <v-spacer />
          <v-btn
            color="primary"
            class="btn-content weeduc-admin-portal-student__save-btn"
            @click="salvarPortalAluno"
            :loading="loading"
            :disabled="loading"
            id="btnSavePortalStudent"
          >
            <span v-if="!loading">Salvar e Publicar</span>
            <span v-else>Carregando...</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import apiAWS from '@/utils/storage/aws'
import apiWebsite from '@/utils/Weflix/content'
import { mapState } from 'vuex'
import CustomFileInput from '@/components/Form/CustomFileInput.vue'
import { toast } from 'vue3-toastify'

export default {
  name: 'PortalStudentImageUpload',
  components: {
    CustomFileInput,
  },
  data() {
    return {
      image: '',
      imagePreview: null,
      imageUpload: null,
      loading: false,
      dataWebsite: null,
      showCertificate: 1,
      showInquiry: 1,
      showForum: 1,
      optionsAtivoInativo: [
        { text: 'Sim', value: 1 },
        { text: 'Não', value: 0 },
      ],
    }
  },
  computed: {
    ...mapState(['token', 'dark']),

    adminSelectMenuProps() {
      return this.dark
        ? { contentClass: 'weeduc-admin-select-menu-dark' }
        : {};
    },
  },
  methods: {
    async getDataWebsite() {
      try {
        const response = await apiWebsite.getWebsite(this.token)
        console.log(response)
        this.dataWebsite = response
        if (response) {
          this.showCertificate = response.showCertificate ?? 1
          this.showInquiry = response.showInquiry ?? 1
          this.showForum = response.showForum ?? 1
          this.image = typeof response.portalBannerFinalPath === 'string' ? response.portalBannerFinalPath : ''
          this.imagePreview = this.image ? this.image : null
        }
      } catch (error) {
        toast.error('Erro ao buscar dados do site')
        console.error('Erro ao buscar dados do site:', error)
      }
    },
    updateFilePath(novoValor) {
      // Se for um arquivo, faz upload para AWS, senão apenas define o path
      if (novoValor && typeof novoValor === 'object' && novoValor instanceof File) {
        // Remove o preview anterior se existir
        if (this.imagePreview && typeof this.imagePreview === 'string' && this.imagePreview.startsWith('blob:')) {
          URL.revokeObjectURL(this.imagePreview)
        }
        this.imagePreview = URL.createObjectURL(novoValor)
        this.uploadImageAws(novoValor)
      } else {
        // Se for string (url), seta o preview para a url
        this.image = novoValor || ''
        this.imagePreview = this.image ? this.image : null
      }
    },
    async uploadImageAws(file) {
      try {
        const assinatura = await apiAWS.getSignatureImage(this.token, file.name)
        await this.putFileAws(assinatura.url, file)
        this.imageUpload = assinatura.token
        // Após upload, o preview já está setado pelo objeto local
      } catch (error) {
        this.notify('Erro ao enviar imagem para o servidor.', 'error')
      }
    },
    async putFileAws(url, file) {
      try {
        await apiAWS.putFileAWS(url, file)
      } catch (error) {
        this.notify('Erro ao salvar a imagem.', 'error')
      }
    },
    notify(mensagem, tipo = 'info') {
      // Aqui você pode integrar com um sistema de toast global, se desejar
      // Exemplo: this.$toast(mensagem, { type: tipo })
      // Por enquanto, apenas loga no console
      console.log(`[${tipo}] ${mensagem}`)
    },
    async salvarPortalAluno() {
      this.loading = true
      try {
        // Garante que portalBannerPath será string ou vazio, nunca objeto
        const payload = {
          ...this.dataWebsite,
          portalBannerPath: this.imageUpload,
          showCertificate: this.showCertificate,
          showInquiry: this.showInquiry,
          showForum: this.showForum,
        }
        const response = await apiWebsite.updateWebsite(
          this.token,
          this.dataWebsite.id,
          payload
        )
        this.notify('Configurações salvas com sucesso!', 'success')
        console.debug(response)
      } catch (error) {
        this.notify('Erro ao atualizar o portal do aluno.', 'error')
        console.error('Erro ao atualizar o portalBannerPath:', error)
      } finally {
        this.loading = false
      }
    },
  },
  beforeUnmount() {
    if (this.imagePreview && typeof this.imagePreview === 'string' && this.imagePreview.startsWith('blob:')) {
      URL.revokeObjectURL(this.imagePreview)
    }
  },
  mounted() {
    this.getDataWebsite()
  },
}
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
@import url('./css/portalStudent.css');
</style>
